module.exports = __webpack_public_path__ + "img/swiper_right_img.92cde32d.png";